import { APPLICATION_STATE, MessagingSystemUserIds } from 'shared-lib'
import { ISendMessageDto } from './automation.dto'
import { ISendMessageSwimlaneFormData } from './job-automation.model'

export type ICultureIndexFormData = ISendMessageSwimlaneFormData

export const cultureIndexDefaults: ICultureIndexFormData = {
  enabled: false,
  message:
    'As part of the application process for this job, we would like for you to please complete a Culture Index survey. You should have received a notification about this and should see an option on your application to complete the survey. Please complete this survey and send it back to continue forward in the application process.',
  senderId: MessagingSystemUserIds.hiring_team,
  delayDuration: 10,
  delayUnits: 'minutes',
  newSwimlane: APPLICATION_STATE.SCREENED,
}
export interface ICultureIndexDto {
  enabled: boolean
  message: ISendMessageDto
  newSwimlane: APPLICATION_STATE | null
  senderId: string
}
